import React from 'react';
import { CardElement, Elements, useElements } from '@stripe/react-stripe-js';

import { useBusy, BusyOverlay } from './busy_component';
import { View, StyleSheet } from './base_components';
import TextButton from './buttons/text_button';

import PaymentMethodStore from '../stores/payment_method_store';

const styles = StyleSheet.create({
  creditCard: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  boxView: {
    alignSelf: 'stretch',
    margin: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  box: {
    flex: 1,
    maxWidth: '40rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  elementView: {
    padding: '1rem',
    display: 'block',
    alignSelf: 'stretch',
    backgroundColor: '#f0f0f0',
  },
  button: {
    marginTop: '1.5rem',
    alignSelf: 'stretch',
  },
});

let g_elements;

type Props = {
  style?: any;
  orgId: number;
  onSuccess: () => void;
};
export default function CreditCard(props: Props) {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const stripe_promise = PaymentMethodStore.loadStripe();

  function _onChange(e, elements) {
    g_elements = elements;
  }
  function _onAddPress() {
    const card = g_elements?.getElement?.(CardElement);
    if (card && setBusy()) {
      const opts = {
        org_id: props.orgId,
        card,
      };
      PaymentMethodStore.createPaymentMethod(opts, (err) => {
        if (err === 412) {
          window.alert('Card declined, please try again.');
        } else if (err) {
          window.alert('Failed to add payment method, please try again.');
        } else {
          props.onSuccess();
        }
        clearBusy();
      });
    }
  }

  return (
    <View style={[styles.creditCard, props.style]}>
      <View style={styles.boxView}>
        <View style={styles.box}>
          <View style={styles.elementView}>
            <Elements stripe={stripe_promise}>
              <CardInner onChange={_onChange} />
            </Elements>
          </View>
          <TextButton
            style={styles.button}
            type='blue'
            text='Add Card'
            onPress={_onAddPress}
          />
        </View>
      </View>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
function CardInner(props) {
  const elements = useElements();
  function _onChange(e) {
    props.onChange(e, elements);
  }
  return (
    <CardElement
      onChange={_onChange}
      options={{
        style: {
          base: {
            fontSize: '16px',
            color: '#181820',
            '::placeholder': {
              color: '#888',
            },
          },
          invalid: {
            color: '#9e2146',
          },
        },
      }}
    />
  );
}
